import React, { FC } from 'react';

import DangerouslySetInnerHtml from 'components/common/DangerouslySetInnerHtml';
import { IProductCardTitle } from './model';

const ProductCardTitle: FC<IProductCardTitle> = ({ title }): React.ReactElement => (
  <DangerouslySetInnerHtml html={title} />
);

export default ProductCardTitle;
